import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "delete",
  "use": "delete-usage",
  "viewBox": "0 0 14 18",
  "content": "<symbol viewBox=\"0 0 14 18\" xmlns=\"http://www.w3.org/2000/svg\" id=\"delete\">\r\n    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M9.5 0H4.5L3.5 1H0V3H14V1H10.5L9.5 0ZM11 6V16H3V6H11ZM1 4H13V16C13 17.1 12.1 18 11 18H3C1.9 18 1 17.1 1 16V4Z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol